// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604231205/js/" + chunkId + "." + {"44":"faa1b8e8","225":"1183e513","481":"70bcf6c7","486":"55147854","770":"09093fce"}[chunkId] + ".0.6612048437320999.chunk.js";
};